import { Controller } from "@hotwired/stimulus"

// Starting Soon overlay row: live-rewrite the `?at=HH:MM` countdown param on the
// row's URL field and the Copy button's clipboard value when the time changes.
export default class extends Controller {
  static targets = ["time", "url", "copy"]
  static values = { base: String }

  update() {
    const at = (this.hasTimeTarget && this.timeTarget.value) || "21:00"
    const full = `${this.baseValue}?at=${at}`
    if (this.hasUrlTarget)
      this.urlTarget.value = full.replace(/^https?:\/\//, "")
    // The clipboard controller reads data-clipboard-value-value at copy time, so
    // updating the attribute is enough — no need to re-init it.
    if (this.hasCopyTarget)
      this.copyTarget.setAttribute("data-clipboard-value-value", full)
  }
}
